import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "../../styles/AuthItems/LoginModal.module.css";
import miloLogo from "../../assets/MILO_WideLogo.png";


const API_BASE_URL = import.meta.env.VITE_API_URL;

function LoginModal({ isOpen, onClose, onLoginSuccess }) {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();  // add navigation hook here ✅
	
	const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            navigate('/');  // Navigate to home when clicking outside
        }
    };

	const handleLogin = async (e) => {
		e.preventDefault();
		setLoading(true);
		setError(null);

		const endpoint = "/auth/demo-login";
		const body = { demoUsername: username, password };

		try {
			const response = await fetch(`${API_BASE_URL}${endpoint}`, {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				credentials: "include",
				body: JSON.stringify(body),
			});

			const data = await response.json();
			if (!response.ok) throw new Error(data.message);

			// Immediately fetch user details
			const authRes = await fetch(`${API_BASE_URL}/auth/check-auth`, { credentials: "include" });
			const authData = await authRes.json();
				if (authData.loggedIn) {
					localStorage.setItem("demoUserId", authData.user.demoUserId);
					localStorage.setItem("tenantUserId", authData.user.tenantUserId);
					localStorage.setItem("landlordUserId", authData.user.landlordUserId);
					localStorage.setItem("username", authData.user.username);
					localStorage.setItem("name", authData.user.name); // <-- ADD THIS
					
					onLoginSuccess(authData.user); 
				}

			navigate('/profile');
		} catch (err) {
			setError(err.message);
		} finally {
			setLoading(false);
		}
	};



    if (!isOpen) return null;

    return (
        <div className={styles.modalOverlay} onClick={handleOverlayClick}>
            <div className={styles.modalContent}>
                <div className={styles.modalHeader}>
					<h2>Welcome to</h2>
                    <img src={miloLogo} alt="MILO Homes Logo" className={styles.loginLogo}/>
                </div>
                <p className={styles.modalSubheader}>
                  This is an alpha version of MILO Homes designed for investors and early testers. Features and design may change substantially before public launch.
                </p>
                {error && <p className={styles.modalError}>{error}</p>}
                <form onSubmit={handleLogin} className={styles.loginForm}>
                    <input
                        type="text"
                        placeholder="Username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                        className={styles.inputField}
                    />
                    <input
                        type="password"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        className={styles.inputField}
                    />
                    <button type="submit" disabled={loading} className={styles.loginButton}>
                        {loading ? "Logging in..." : "Login"}
                    </button>
                    <a href="mailto:support@milohomes.com?subject=Forgot Password" className={styles.forgotPassword}>
                      Forgot Password?
                    </a>
                </form>
                <div className={styles.modalFooter}>
                    Need access? <a href="mailto:contact@milohomes.com">Request here</a>.
                </div>
            </div>
        </div>
    );
}

export default LoginModal;
